// These helpers work with strings instead of specific enum types.
// This is because multiple versions of the ReportStatus enum currently exist in the codebase.
// By working with strings, these functions can support both (and future) versions without type conflicts.

export const STATUSES_WITH_OWN_ICONS = [
  'DONE',
  'PLACEMENT_OF_HUB_DONE',
  'PLACEMENT_OF_SITE_DONE',
  'PERMIT_DONE',
] as const;

export function mapStatusForIcon(reportStatus: string): string {
  if (reportStatus === 'NOT_STARTED') {
    return 'UNKNOWN';
  } else if (
    (STATUSES_WITH_OWN_ICONS as readonly string[]).includes(reportStatus)
  ) {
    return reportStatus;
  } else {
    return 'IN_PROGRESS';
  }
}

export function getIconUrlForStatus(
  markerType: string,
  reportStatus: string,
): string {
  const statusForIcon = mapStatusForIcon(reportStatus);
  return `assets/leaflet/images/point-icons/${markerType}/${statusForIcon}.svg`;
}
